import { List, ListItem } from "@mui/material";
import ProductCard from "./ProductCard";
import { productListStyles } from "./styles";

interface IProps {
  products: ICartProduct[];
}

const CartList: React.FC<IProps> = ({ products }) => {
  return (
    <List disablePadding>
      {products.map((product) => (
        <ListItem disablePadding key={product.id} sx={productListStyles}>
          <ProductCard product={product} />
        </ListItem>
      ))}
    </List>
  );
};

export default CartList;
